import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { CuepidCoreModule } from '@cuepid/core';
import { EgretModule } from '@cuepid/egret';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { HeaderSideComponent } from './header-side/header-side.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { LoadIndicatorComponent } from './load-indicator/load-indicator.component';
import { SidebarSideComponent } from './sidebar-side/sidebar-side.component';

const components = [
  SidebarSideComponent,
  HeaderSideComponent,
  AdminLayoutComponent,
  AuthLayoutComponent,
  LoadIndicatorComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSidenavModule,
    MatButtonModule,
    MatRippleModule,
    MatDialogModule,
    EgretModule,
    CuepidCoreModule,
  ],
  declarations: components,
  entryComponents: [],
  exports: components,
})
export class SharedComponentsModule {}
